import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class ProviderController extends BaseController {
  model = DataConst.MODELS.PROVIDER;
}

export default new ProviderController();
